import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { Typography } from '@mui/material'

interface Props {
    isActive: boolean
    name: string
    onReset: () => void
}

const BadgeFilter = ({ isActive, name }: Props) => {
    return (
        <div className={'badge-filter' + (isActive ? ' active-badge-filter' : '')}>
            <Typography marginRight={1} marginLeft={1} variant='body2'>{name}</Typography>
            <FilterAltIcon fontSize='inherit' />
        </div>
    )
}

export default BadgeFilter
